<template>
    <div class="logSearch">
        <Row :gutter="4">
            <!-- 选择公司 -->
            <div v-if="company==1">
              <Col span="4">
                  <Select v-model="companyId" filterable :placeholder="$t('alarms.common.pleaseSelectCompany')" :transfer="true" @on-change="searchCompany">
                      <Option value=" " selected>{{ $t('alarms.common.all') }}</Option>
                      <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                  </Select>
              </Col>
            </div>
            <Col span="4">
                <Select v-model="stateSearchKey" filterable :placeholder="$t('alarms.log.application.region')"  @on-change="searchRegion(stateSearchKey)" :transfer="true">
                    <Option value="" selected>{{ $t('alarms.common.allRegion') }}</Option>
                    <Option :value="item.name" v-for="item in regionList" :key="item.name">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="4">
                <!-- v-on:input实时查询 -->
                <Input search v-model="instanceIdSearchKey" :placeholder="$t('alarms.log.application.instanceId')" @on-search="searchInstanceId()"/>
            </Col>
        </Row>
    </div>
</template>
<script>
    import TableLog from '../log/TableLog'
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    var tableLog = TableLog;
    export default {
        name: 'LogMonitorSearch',
        data () {
            return {
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                stateSearchKey: [],
                instanceIdSearchKey:'',
                instanceIdSearchName:'',
                regionList:[],
                regionName:''
            }
        },
        mounted: function(){
            this.getQueryRegions();
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
        },
        methods: {
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
               this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                 .then(res => {
                     this.companyList = res.data;
                 });
             },
            // 按公司搜索
            searchCompany: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('companyId', this.companyId);
                tableLog.methods.showAll();
            },
            //查询地区
            getQueryRegions: function(){
                this.$api.account.queryRegions("userName",getCookie(global.cookieName))
                    .then(res => {
                        this.regionList = res.data; 
                    })
            },
            // 按状态筛选
            searchRegion: function(){
                eventBus.$emit('regionName', this.stateSearchKey);
                tableLog.methods.showAll();
            },
            // 按实例ID搜索
            searchInstanceId: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('instanceIdSearchName', this.instanceIdSearchKey);
                tableLog.methods.showAll();
            }

        }
    }
</script>
<style scoped>
    .logSearch
    {
        height: 51px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/logs/log/LogMonitorSearch.vue